module.exports = __webpack_public_path__ + "img/illustration.887b4aad.svg";